<template>
  <div class="page">
        <!-- 搜索 -->
<!--  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>-->
<!--              <el-form-item label="班级">-->
<!--                  <el-input  v-model="queryForm.classId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="课程">-->
<!--                  <el-input style="width: 177px" v-model="queryForm.courseId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduClassCourseList">查询</el-button>-->
<!--                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>-->
<!--              </el-form-item>-->
<!--  </el-form>-->
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduClassCourse"
        >添加</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduClassCourse(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduClassCourse(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduClassCourseList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduClassCourseList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduClassCourseList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="classId"-->
<!--        label="班级"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="courseId"
        label="课程"
      >
          <template slot-scope="scope">
            {{ scope.row.course ? scope.row.course.courseName : '' }}
          </template>
      </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="courseId"
            label="课程类型"
        >
            <template slot-scope="scope">
                {{ scope.row.course ? scope.row.course.category.categoryName : '' }}
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="courseId"
            label="授课教师"
        >
            <template slot-scope="scope">
                {{ scope.row.course ? scope.row.course.teacher.teacherName : '' }}
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="courseId"
            label="课程价格"
        >
            <template slot-scope="scope">
                {{ scope.row.course ? scope.row.course.coursePrice : '' }}
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="createTime"-->
<!--        label="创建时间"-->
<!--      > </el-table-column>-->
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduClassCourse(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
            <div @click="editEduClassCourse(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduClassCourse(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduClassCourseStates[eduClassCourseState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduClassCourse"
          ref="eduClassCourseForm"
          :rules="rules"
          label-width="60"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="班级"-->
<!--            prop="classId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClassCourse.classId"-->
<!--              :disabled="eduClassCourseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="课程"
            prop="courseId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="eduClassCourse.courseId"-->
<!--              :disabled="eduClassCourseState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择课程" labelName="courseName" :disabled="eduClassCourseState == 'check'"
                           labelValue="id" :value="eduClassCourse.courseId" :limit='1' size='small' placeholder='请选择课程'
                           @getValue="getValueUser" :columns="EDUCLASSCOURSE_code" :searchs="EDUCLASSCOURSE_search" dataListUrl="/edu/course/findList" entityBeanName="eduCourse" queryEntityUrl="/edu/course/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClassCourse.sort"-->
<!--              :disabled="eduClassCourseState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduClassCourseState == 'check'"
                  v-model="eduClassCourse.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduClassCourseState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { EDUCLASSCOURSE, EDUCLASSCOURSE_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduClassCourseList();
                    this.getEduClassCourseList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduClassCourseList();
                    this.getEduClassCourseList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     classId: '', //班级
                     courseId: '', //课程
                     sort: '', //排序
                },
                EDUCLASSCOURSE_code: EDUCLASSCOURSE,
                EDUCLASSCOURSE_search: EDUCLASSCOURSE_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduClassCourseState: 'add',
                eduClassCourseStates: {
                    add: '添加班级课程',
                    check: '查看班级课程',
                    edit: '修改班级课程'
                },

                multipleSelection: [],
                eduClassCourseList: [],
                eduClassCourse: {
                    id: '', //ID
                    classId: '', //班级
                    courseId: '', //课程
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    classId: [{ required: true, message: '班级不能为空', trigger: 'blur' }],
                    courseId: [{ required: true, message: '课程不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            init(item){
                this.queryForm.classId = item;
                this.eduClassCourse.classId = item;
                this.getEduClassCourseList();
            },
            getValueUser(value) {
                this.eduClassCourse.courseId = value
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetEduClassCourseList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduClassCourseList = [];
            },
            resetDialog() {
                this.eduClassCourseState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      classId: this.queryForm.classId, //班级
                      courseId: '', //课程
                      sort: '', //排序
                };
                this.getEduClassCourseList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduClassCourse = {
                      id: '', //ID
                      classId: this.eduClassCourse.classId, //班级
                      courseId: '', //课程
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduClassCourseState == 'add') {
                    this.$refs.eduClassCourseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/classcourse/add`,{ ...this.eduClassCourse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduClassCourseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduClassCourseState == 'edit') {
                    this.$refs.eduClassCourseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduClassCourse.course
                            post(`/edu/classcourse/edit`,{ ...this.eduClassCourse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduClassCourseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduClassCourse() {
                this.showDialog = true;
                this.eduClassCourseState = 'add';
            },
            checkEduClassCourse(eduClassCourseId) {
                console.log(eduClassCourseId);
                this.currentEduClassCourseId = eduClassCourseId;

                this.getEduClassCourseById();
                this.showDialog = true;
                this.eduClassCourseState = 'check';
            },
            editEduClassCourse(eduClassCourseId) {
                console.log('eduClassCourse', eduClassCourseId);
                if (eduClassCourseId) {
                    this.currentEduClassCourseId = eduClassCourseId;
                    this.getEduClassCourseById();
                } else {
                    this.eduClassCourse = { ...this.eduClassCourse, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduClassCourseState = 'edit';
            },
            deleteEduClassCourse(eduClassCourseId) {
                let ids = '';
                if (eduClassCourseId) {
                    ids = eduClassCourseId;
                } else {
                    ids = this.multipleSelection.map((eduClassCourse) => eduClassCourse.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/classcourse/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduClassCourseList();
                                this.getEduClassCourseList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduClassCourseList() {
                this.resetEduClassCourseList();
                this.getEduClassCourseList();
            },
            getEduClassCourseList(query = {}) {
                this.loading = true;
                get(`/edu/classcourse/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduClassCourseList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduClassCourseById() {
                get(`/edu/classcourse/get`,{ id: this.currentEduClassCourseId }).then((res) =>{
                    if(res.success){
                      this.eduClassCourse = { ...this.eduClassCourse, ...res.eduClassCourse };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduClassCourseList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/classcourse/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/classcourse/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/classcourse/importData`,formData);
              this.refreshEduClassCourseList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduClassCourseList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduClassCourseList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>